module.exports = __webpack_public_path__ + "media/src/assets/img/elements/apple-watch-c51a5f8c467153ef51b6275e0c0a32fb.png";